<template>
  <div class="customerDeliveryAddressList">
    <vm-table
        ref="vmTable"
        height="64vh"
        :filter.sync="filter"
        module="basic"
        url="customerDeliveryAddress/pageList">
      <div slot="toolbar">
        <el-button type="primary" @click="$refs.editAddress.open()">新建</el-button>
      </div>
      <template slot="adSearch">
        <div class="vm-search">
          <vm-search label="客户编号">
            <el-input v-model.trim="filter.customerNo" clearable/>
          </vm-search>
          <vm-search label="客户名称">
            <el-input v-model.trim="filter.customerName" clearable/>
          </vm-search>
          <vm-search label="客户编号">
            <el-input v-model.trim="filter.outerNo" clearable/>
          </vm-search>
          <vm-search label="是否终端客户">
            <el-select v-model="filter.isEndCustomer" clearable>
              <el-option label="是" :value="1"/>
              <el-option label="否" :value="0"/>
            </el-select>
          </vm-search>
          <vm-search label="所属销售员">
            <el-input v-model.trim="filter.salesName" clearable/>
          </vm-search>
        </div>
      </template>
      <el-table-column align="center" prop="outerNo" label="客户编号" width="90px"/>
      <el-table-column align="center" prop="customerName" label="客户名称"/>
      <el-table-column align="center" prop="addressName" label="所在区域" width="120px"/>
      <el-table-column align="center" prop="addressDetail" label="详细地址"/>
      <el-table-column align="center" prop="contact" label="联系人" width="90px"/>
      <el-table-column align="center" prop="telephone" label="电话" width="120px"/>
      <el-table-column align="center" prop="isDefault" label="是否默认地址" width="100px">
        <template slot-scope="scope">
          <el-tag>
            {{scope.row.isDefault ? "是" : "否"}}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="note" label="备注" show-overflow-tooltip/>
      <el-table-column label="操作" align="center" width="260px">
        <template slot-scope="scope">
          <el-button v-if="scope.row.status === 0" type="primary" @click="$refs.editAddress.open(scope.row)">编辑</el-button>
          <el-button v-if="scope.row.status === 0" type="success" @click="submitRow(scope.row)">提交</el-button>
<!--          <el-button type="primary" @click="$refs.attachment.open(scope.row)">附件</el-button>-->
          <el-button v-if="scope.row.status === 0" type="danger" @click="deleteRow(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </vm-table>
    <customer-delivery-address-edit ref="editAddress" @save-success="getList(1)"/>
    <customer-delivery-address-attachment ref="attachment"/>
  </div>
</template>
<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";
  import CustomerDeliveryAddressEdit from "@/views/customer/CustomerDeliveryAddressEdit";
  import CustomerDeliveryAddressAttachment from "@/views/customer/CustomerDeliveryAddressAttachment";

  export default {
    name: "CustomerDeliveryAddressList",
    components: {VmTable, VmSearch, CustomerDeliveryAddressEdit, CustomerDeliveryAddressAttachment},
    data() {
      return {
        filter: {
          customerNo: "",
          customerName: "",
          salesName: "",
          outerNo: "",
          companyNo: "",
          isEndCustomer: "",
          accessoryVoList: [],
        },
      };
    },
    mounted() {
      this.$refs.vmTable.getList(1);
    },
    methods: {
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
      deleteRow(row) {
        this.$confirm("确定删除吗?", "提示", {type: "warning"}).then(() => {
          this.$http
            .delete("basic", "customerDeliveryAddress", row.pkid).then(() => {
              this.getList(-1);
              this.$message.success("删除成功");
            });
        });
      },
      submitRow(row) {
        this.$confirm("确定提交吗?", "提示", {type: "warning"}).then(() => {
          this.$http
            .post("basic", `customerDeliveryAddress/submit/${row.pkid}`).then(() => {
              this.getList(1);
              this.$message.success("提交成功");
            });
        });
      },
    },
  };
</script>
<style lang="scss" scoped>
</style>
